import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
/** @jsx jsx  */

import { Button } from '@datacamp/waffles/button';
import tokens from '@datacamp/waffles-tokens';
import { jsx } from '@emotion/react';
import { jsx as ___EmotionJSX } from "@emotion/react";
const baseStyle = {
  alignItems: 'start',
  borderRadius: tokens.borderRadius.medium,
  cursor: 'pointer',
  fontWeight: tokens.fontWeights.bold,
  padding: 12
};
const activeStyle = _objectSpread(_objectSpread({}, baseStyle), {}, {
  backgroundColor: tokens.colors.white,
  borderColor: tokens.colors.blue,
  boxShadow: tokens.boxShadow.medium
});
const inactiveStyle = _objectSpread(_objectSpread({}, baseStyle), {}, {
  backgroundColor: tokens.colors.greySubtle
});
export const MenuItem = _ref => {
  let {
    active,
    'data-testid': dataTestId,
    'data-trackid': dataTrackId,
    onClick,
    text
  } = _ref;
  return jsx(Button, {
    css: active ? activeStyle : inactiveStyle,
    "data-testid": dataTestId,
    "data-trackid": dataTrackId,
    onClick: onClick,
    size: 'medium'
  }, text);
};